"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _countdownMessageModule = _interopRequireDefault(require("./countdown-message.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CountdownMessage = function CountdownMessage(_ref) {
  var className = _ref.className,
    _ref$cutOffTime = _ref.cutOffTime,
    cutOffTime = _ref$cutOffTime === void 0 ? 0 : _ref$cutOffTime,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 3 : _ref$duration,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'Order in the next {time} to collect in-store from 3pm tomorrow' : _ref$message;
  var FIVE_MINUTES_IN_MS = 300000;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTimer = _useState2[0],
    setShowTimer = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loadedWithin5Minutes = _useState4[0],
    setLoadedWithin5Minutes = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    timeObject = _useState6[0],
    setTimeObject = _useState6[1];
  var addHours = function addHours(date) {
    date.setHours(cutOffTime, 0, 0);
    return date;
  };
  var processTemplate = function processTemplate(replacements, index) {
    var split = message.split(/({.*?})/g);
    return split.map(function (string) {
      var replacedString = replacements[string];
      var key = "".concat(string, "-").concat(index);
      if (replacedString) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react["default"].Fragment, {
        children: replacedString
      }, key);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react["default"].Fragment, {
        children: string
      }, key);
    });
  };
  _react["default"].useEffect(function () {
    var countDownDate = addHours(new Date());
    setLoadedWithin5Minutes(countDownDate.getTime() - new Date().getTime() < FIVE_MINUTES_IN_MS);
    var interval = setInterval(function () {
      var now = new Date();
      setShowTimer(cutOffTime - now.getHours() <= duration);
      var timeLeft = countDownDate.getTime() - now.getTime();
      var hours = Math.floor(timeLeft % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      var minutes = Math.floor(timeLeft % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(timeLeft % (1000 * 60) / 1000);
      setTimeObject({
        hours: hours,
        minutes: minutes,
        seconds: seconds
      });
      if (timeLeft < 0) {
        clearInterval(interval);
      }
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, [duration, cutOffTime]);
  var pluralise = function pluralise(units, noun) {
    return "".concat(units, " ").concat(noun).concat(units !== 1 ? 's' : '');
  };
  var hours = timeObject.hours,
    minutes = timeObject.minutes,
    seconds = timeObject.seconds;
  var hoursDisplay = hours ? pluralise(hours, 'hour') : '';
  var minutesDisplay = minutes ? pluralise(minutes, 'minute') : '';
  var secondsDisplay = !hours && minutes < 2 && seconds ? pluralise(seconds, 'second') : '';
  var timeDisplay = "".concat(hoursDisplay, " ").concat(minutesDisplay, " ").concat(secondsDisplay);
  var replacements = {};
  replacements['{time}'] = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: _countdownMessageModule["default"].time,
    children: timeDisplay
  });
  var result = processTemplate(replacements);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !loadedWithin5Minutes && showTimer && (hours > 0 || minutes > 0 || seconds > 0) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames["default"])(className, _countdownMessageModule["default"].container),
      children: result
    }) : null
  });
};
CountdownMessage.propTypes = {
  /** Cutoff time hour 0 - 24 */
  cutOffTime: _propTypes["default"].number.isRequired,
  /** Duration in hours 1 - 24 */
  duration: _propTypes["default"].number,
  /** Message */
  message: _propTypes["default"].string,
  /** Optional container class name */
  className: _propTypes["default"].string
};
CountdownMessage.defaultProps = {
  cutOffTime: 0,
  duration: 3,
  message: 'Order in the next {time} to collect in-store from 3pm tomorrow',
  className: ''
};
var _default = exports["default"] = CountdownMessage;